/**
 * Wo auf der Fortschrittsleiste liegt eine Zeit?
 *
 * Die Leiste zeigt ein ganzes Kapitel als eine Strecke, obwohl dahinter mehrere
 * Audiodateien liegen. Diese Rechnung übersetzt zwischen beidem: aus der Sekunde im
 * Kapitel wird die Datei plus die Sekunde in ihr.
 *
 * Sie stand vorher zweimal im Player - einmal beim Loslassen, einmal für die Vorschau
 * während des Ziehens - und die beiden Fassungen waren nicht ganz gleich: nur eine
 * fing den Fall ab, dass man über das Ende hinauszieht. Hier fängt ihn beides ab.
 */
export type ScrubTarget = { index: number; timeWithin: number }

export function segmentAtTime(segments: number[], time: number): ScrubTarget | null {
  if (segments.length === 0) return null

  let accumulated = 0
  for (let i = 0; i < segments.length; i++) {
    if (time < accumulated + segments[i]) {
      return { index: i, timeWithin: Math.max(0, time - accumulated) }
    }
    accumulated += segments[i]
  }

  // Hinter dem Ende: die letzte Datei, an ihrem Ende.
  const last = segments.length - 1
  return { index: last, timeWithin: Math.max(0, segments[last]) }
}

/** Anteil der Leiste, auf den ein Zeigerpunkt fällt - immer zwischen 0 und 1. */
export function fractionOfBar(clientX: number, rect: { left: number; width: number }): number {
  if (rect.width <= 0) return 0
  return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width))
}
